import * as actionsType from "./actionsType";

export const changeLang = (lang) => {
  return {
    type: actionsType.NEW_LANG,
    payload: lang,
  };
};
